import React from "react";
import ContinuousDelivery from "git/ee/components/ContinuousDelivery";

function TabContinuousDelivery() {
  return <ContinuousDelivery />;
}

export default TabContinuousDelivery;
